export default __webpack_public_path__ + "static/media/wi_01n_clear_sky.74ee44aa.svg";